<template>
    <div class="project_header">
        <div class="project_header_top">
            <ul class="project_header_log">
                <li @click="$router.push({name:'myInfo'})">
                    <el-avatar :size="52" :src="userInfo.userIconToVerify || '/static/images/user_pic.jpg'"></el-avatar>
                    <span>{{userInfo.nickName || '--'}}</span>
                </li>
                <li @click="logoutsys">
                    <i class="iconfont icon-quit"></i>
                    <span>退出系统</span>
                </li>
            </ul>
            <div :class="'project_header_box '+($store.getters.isAdmin?'cursorp':'')"  @click="$store.getters.isAdmin&&$router.push({name:'comInfo'})">
                <el-avatar :size="76" :src="userInfo.coLogoToVerify || '/static/images/coLogo.jpg'"></el-avatar>
                <h2>{{userInfo.coName}}</h2>
                <span>欢迎来到物业房产服务系统！</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: "projectHeader",
        computed: mapGetters(['userInfo']),
        methods: {
            logoutsys: function () {
                var that = this;
                this.logout().then(() => {
                    that.$router.push({name: "login"})
                })
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/projectHeader.vue